import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import Pagination from 'components/Pagination';
import Footer from 'components/Footer';
import * as DataList from 'components/DataList';

// Layout shared by the list and its loading skeleton (pages/suppliers/index.js).
export const SUPPLIER_COLUMNS = [
  { area: 'name', label: 'Name', width: 'minmax(180px, 1.2fr)', bone: 'single' },
  { area: 'contact', label: 'Contact details', width: 'minmax(200px, 1.2fr)', icon: 'envelope' },
  { area: 'address', label: 'Address', width: 'minmax(220px, 2fr)', bone: 'single', icon: 'map-marker' },
  { area: 'actions', label: '', width: '40px', bone: 'none' },
];

export const SUPPLIER_CARDS = {
  columns: 'minmax(0, 1fr) auto',
  areas: ['name actions', 'contact contact', 'address address'],
};

export const SUPPLIER_MIN_TABLE_WIDTH = 640;

// loadSuppliers always asks for newest first, whatever supplierSearch.order says.
const SUPPLIER_ORDER = { created_at: 'desc' };

@inject('store', 'supplierStore', 'viewStore') @observer
class SuppliersTable extends Component {

  @observable isDeleteDialogVisible = false;
  @observable client;

  

  onPaginationChange(newPage) {
    let {
      viewStore: {
        supplierSearch
      }
    } = this.props;
    this.props.viewStore.supplierSearch = {
      ...supplierSearch,
      page: newPage
    };
    this.props.viewStore.suppliers();
  }

  

  // Empty list's "Clear search": back to all suppliers, page 1.
  clearSearch() {
    const { viewStore } = this.props;
    viewStore.supplierSearch = { ...viewStore.supplierSearch, term: '*', page: 1 };
    viewStore.bumpListFilters();
    viewStore.suppliers();
  }

  handleSupplierClick(event, supplier) {
    switch (event.label) {
      case 'Edit':
        this.supplier = supplier;
        this.props.viewStore.supplierShow({uuid: supplier.attributes.id})
        break;
      case 'Delete':
        this.isDeleteDialogVisible = true;
        this.supplier = supplier;
        break;
      default:
    }
  }

  render() {
    let {
      viewStore,
      supplierStore: {
        suppliers: {
          objects,
          meta
        }
      }
    } = this.props;
    const { supplierSearch } = viewStore;
    const term = supplierSearch.term && supplierSearch.term !== '*' ? supplierSearch.term : '';

    if (objects.length === 0) {
      return (
        <DataList.Empty
          noun="suppliers"
          term={term}
          onClearFilters={this.clearSearch.bind(this)}
        />
      );
    }
    return (
      <React.Fragment>
        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
        <DataList.List
          columns={SUPPLIER_COLUMNS}
          cards={SUPPLIER_CARDS}
          minTableWidth={SUPPLIER_MIN_TABLE_WIDTH}
          total={meta.total_records || objects.length}
          noun="suppliers"
          note={DataList.sortNote(SUPPLIER_ORDER)}
        >
          {objects.map((supplier) => {
            const attributes = supplier.attributes;
            const { email, phone } = attributes;
            return (
              <DataList.Row key={supplier.id}>
                <DataList.Cell area="name">
                  <DataList.RowLink
                    href={`/dashboard/suppliers/${attributes.id}/show`}
                    label={`Supplier ${attributes.name}`}
                  >
                    {attributes.name}
                  </DataList.RowLink>
                </DataList.Cell>
                <DataList.Cell area="contact">
                  {email || phone ? (
                    <DataList.Lines
                      primary={email || phone}
                      secondary={email ? phone : null}
                      strong={false}
                    />
                  ) : (
                    <DataList.Muted>No contact details</DataList.Muted>
                  )}
                </DataList.Cell>
                <DataList.Cell area="address">
                  {attributes.address ? (
                    <DataList.Lines primary={attributes.address} strong={false} />
                  ) : (
                    <DataList.Muted>—</DataList.Muted>
                  )}
                </DataList.Cell>
                <DataList.Cell area="actions">
                  <DataList.Actions
                    items={[
                      { icon: 'edit', label: 'Edit supplier', onClick: () => viewStore.supplierShow({ uuid: attributes.id }) },
                    ]}
                  />
                </DataList.Cell>
              </DataList.Row>
            );
          })}
        </DataList.List>

        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
      </React.Fragment>
    )
  }
}

export default SuppliersTable;